import React from 'react';
import MoneyBackGuarantee from '../../../components/MoneyBackGuarantee/MoneyBackGuarantee';
import styles from './Modern.module.sass';
import safe from './img/safe.webp';

export default function GuaranteeBlock({ offer }) {
  return (
    <div className={styles.guaranteeBlock}>
      <div className={styles.guaranteeHeader}>
        <div className={styles.secureIcon}>
          <i className="fa-solid fa-shield-check"></i>
        </div>
        <div className={styles.secureText}>
          <h4>SSL Secure Payment</h4>
          <p>Your personal details are securely encrypted with 256-bit SSL.</p>
        </div>
      </div>

      <div className={styles.guaranteeContent}>
        <MoneyBackGuarantee />
      </div>

      <div className={styles.trustBadges}>
        <img src={safe} alt="Trust Badges" />
      </div>

      {offer.benefits && offer.benefits.length > 0 && (
        <div className={styles.guaranteeBenefits}>
          {offer.benefits.map((benefit, index) => (
            <div key={index} className={styles.guaranteeBenefit}>
              <div className={styles.checkIcon}>
                <i className="fa-solid fa-check"></i>
              </div>
              <p dangerouslySetInnerHTML={{ __html: benefit }}></p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
